import axios from 'axios';
import { PRICING_CAPABILITIES_V1_URL, PRODUCT_SERVICE_URL } from './configuration';
import { setSnackbar } from './generic-action';

const SHIPPING_RULES_ENDPOINT = {
  SHIPPING_RULES: '/shippingRules'
};

export const getShippingRuleMapping = (productId) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${PRICING_CAPABILITIES_V1_URL}/productShippingRuleMappings/productSku?productId=${productId}`
    );
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message: error?.response?.data?.message || error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

export const getShippingRules =
  ({ page, size } = {}) =>
  async (dispatch) => {
    try {
      if (!page && !size) {
        const response = await axios.get(
          `${PRICING_CAPABILITIES_V1_URL}/shippingRules`
        );
        const rules = response.data.content || [];
        return rules.filter((rule) => rule.isActive === true);
      } else {
        const response = await axios.get(
          `${PRICING_CAPABILITIES_V1_URL}${SHIPPING_RULES_ENDPOINT.SHIPPING_RULES}?page=${page}&size=${size}`
        );
        return response.data;
      }
    } catch (error) {
      dispatch(
        setSnackbar({
          showSnackbar: true,
          message: error?.response?.data?.message || error?.message,
          severity: 'error'
        })
      );
      return null;
    }
  };

export const saveShippingRuleMapping = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${PRICING_CAPABILITIES_V1_URL}/productShippingRuleMappings`,
      payload
    );
    return response.data;
  } catch (error) {
    dispatch({
      type: 'ERROR',
      error: {
        data: {
          message: error?.response?.data?.message || error?.message
        }
      }
    });
    return false;
  }
};

export const updateShippingRuleMapping =
  (mappingId, payload) => async (dispatch) => {
    try {
      const response = await axios.put(
        `${PRICING_CAPABILITIES_V1_URL}/productShippingRuleMappings/${mappingId}`,
        payload
      );
      return response.data;
    } catch (error) {
      dispatch({
        type: 'ERROR',
        error: {
          data: {
            message: error?.response?.data?.message || error?.message
          }
        }
      });
      return false;
    }
  };

/**
 * Create a new shipping rule
 */
export const createShippingRule = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${PRICING_CAPABILITIES_V1_URL}${SHIPPING_RULES_ENDPOINT.SHIPPING_RULES}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message: error?.response?.data?.message || error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

/**
 * Update an existing shipping rule
 */
export const updateShippingRule = (shippingRuleId, payload) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${PRICING_CAPABILITIES_V1_URL}${SHIPPING_RULES_ENDPOINT.SHIPPING_RULES}/${shippingRuleId}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message: error?.response?.data?.message || error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

/**
 * Delete a shipping rule
 */
export const deleteShippingRule = (shippingRuleId) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${PRICING_CAPABILITIES_V1_URL}${SHIPPING_RULES_ENDPOINT.SHIPPING_RULES}/${shippingRuleId}`
    );
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message: error?.response?.data?.message || error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

/**
 * Get shipping sac codes
 */
export const getShippingSacCodes = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${PRODUCT_SERVICE_URL}/taxCodes?shippingType=YES`
    );
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message: error?.response?.data?.message || error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

export const deleteShippingRuleMapping = (mappingId) => async (dispatch) => {
  try {
    await axios.delete(
      `${PRICING_CAPABILITIES_V1_URL}/productShippingRuleMappings/${mappingId}`
    );
    return true;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message: error?.response?.data?.message || error?.message,
        severity: 'error'
      })
    );
    return false;
  }
};
